import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Home from "@/pages/public/Home";
import ActPage from "@/pages/public/ActPage";
import Decoder from "@/pages/public/Decoder";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-neutral-500">Загрузка…</div>;
  if (!user) return <Navigate to="/ci-panel-7x9k2/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/act/:token" element={<ActPage />} />
          <Route path="/decoder" element={<Decoder />} />
          <Route path="/ci-panel-7x9k2/login" element={<Login />} />
          <Route
            path="/ci-panel-7x9k2/*"
            element={
              <Protected>
                <AdminLayout />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
